import { createSelector } from '@reduxjs/toolkit';
import { selectDealType } from 'shared/selectors/jsonQuery';
import {
  selectHasDistricts,
  selectHasHighways,
  selectHasRegionalDistricts,
  selectHasUnderground,
} from 'shared/selectors/location';
import { FDealType } from '../../../../packages/JsonQuery';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { EPageType } from 'shared/types/page';

export enum EGeoType {
  Underground = 1,
  RegionalDistricts = 2,
  District = 3,
  Highway = 4,
  Address = 5,
}

export const selectGeoTypeFilter = createSelector(
  [
    selectHasUnderground,
    selectHasRegionalDistricts,
    selectHasDistricts,
    selectHasHighways,
    selectDealType,
    selectPageType,
  ],
  (hasUnderground, hasRegionalDistricts, hasDistricts, hasHighways, dealType, pageType) => {
    const geoTypeItems = [];

    if (pageType === EPageType.SEARCH || pageType === EPageType.MAIN) {
      geoTypeItems.push({ text: 'Адрес', id: EGeoType.Address });
    }

    if (hasUnderground) {
      geoTypeItems.push({ text: 'Метро', id: EGeoType.Underground });
    }

    if (hasRegionalDistricts) {
      geoTypeItems.push({ text: 'Район', id: EGeoType.RegionalDistricts });
    }

    if ((dealType !== FDealType.RentDaily || !hasUnderground) && hasDistricts && !hasRegionalDistricts) {
      geoTypeItems.push({ text: 'Район', id: EGeoType.District });
    }

    if (
      hasHighways &&
      (dealType !== FDealType.RentDaily || hasUnderground) &&
      (!hasDistricts || hasRegionalDistricts)
    ) {
      geoTypeItems.push({ text: 'Шоссе', id: EGeoType.Highway });
    }

    const geoTypeLabel = geoTypeItems
      .map(item => item.text)
      .filter(Boolean)
      .join(', ');

    return { label: geoTypeLabel || '', tabItems: geoTypeItems.filter(({ id }) => id !== EGeoType.Address) };
  },
);
